import { render } from "./CommissionTransfer.vue?vue&type=template&id=48984694"
import script from "./CommissionTransfer.vue?vue&type=script&lang=js"
export * from "./CommissionTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__